import { render, staticRenderFns } from "./LastTimeUpdated.vue?vue&type=template&id=b0c99376&scoped=true&"
import script from "./LastTimeUpdated.vue?vue&type=script&lang=js&"
export * from "./LastTimeUpdated.vue?vue&type=script&lang=js&"
import style0 from "./LastTimeUpdated.vue?vue&type=style&index=0&id=b0c99376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c99376",
  null
  
)

export default component.exports